//  英文
export default {
    // 官网首页
    language: 'language',
    Data_terminal_products: 'Data terminal',
    industrial_product: 'Industry',
    mobile_terminal: 'Mobile',
    contact_us: 'Contact',
    Project_customization: 'Project Customization',
    recruitment_information: 'Recruitment Information',
    Technology_team: 'Technology',
    Search: 'Search',
    Please_enter_keywords: 'Please enter keywords!',
    No_such_search_term: 'There is no such search term. Please enter another keyword to try!',
    product: 'ProductS',
    four_industrial_gateway: '4G Industrial',
    five_industrial_gateway: '5G Industrial',
    modular: 'Modular',
    MTK: 'MTK',
    high_pass: 'High Pass',
    Rock_Chip: 'Rock Chip',
    company: 'Company Profile',
    company_title: 'Shenzhen MifiData Technology Co., Ltd.',
    p1: 'Shenzhen MifiData Technology Co., Ltd. is an innovative technology company, was foundedin 2007. And in early 2013, the company vigorously'+
    'the introduction of industry professionals set up R & D headquarters in Shenzhen Science and Technology Park, the Mifidata company with the'+
    'Beijing University of Posts and Telecommunications jointly established mobile Internet research and development centers, and Established a'+
    'long-term strategic partnership with the world first-class chip suppliers like Qualcomm,Sequans etc , purchase 4 Rohde & Schwarz CMW500'+
    'comprehensive measurement for R & D .',
    p2: 'Our company is mainly engaged in the 5G NSA/SA CPE & 5G MiFi & 5G USB WiFi Dongle, 5G Module, 5G Industrial Router, 4G LTE wireless'+ 
    'router (MIFI), 4G LTE dongle,4g modules, CPE and other R&D projects. Dedicated to a data communication terminal demand and industry-specific'+
    'R&D, and provide series of solutions from the terminal to the wireless network system . So far, Product has covered more than 100 countries'+
    'all over the world and provided OEM/ODM service to some famous foreign telecom operators and locate king.We have independent research and'+
    'design ability for our all products. And allitems can be modified and customized for customer requirement. Excellent team and independent'+
    'intellectual property rights help customers organize project implementation plan. Pre-sales,R & D department staff help to analyze customer'+
    'demand, in order to communicate more effective that can save time .The entire project process will be followed by the professional and technical'+
    'personnel. MifiData will always stick to the innovation, quality, service, serious, responsible, thanksgiving 12 words philosophy. Absorb new'+
    'ideas, strict to quality, a full range of tracking service, adhere to make high quality products.Quality first is our management aim. Providing'+
    'superior products and thoroughtechnical communication solutions services by innovating constantly for all customers. MiFiData will follow market'+
    'trends closely, gradually moving towards the international market by innovation and technology improvement. Our goal is to become a world-class 4G'+
    'data terminal OEM / ODM designer and manufacturer.',
    characteristic: 'Characteristic',
    Hot_selling_series: 'Hot Selling Series',
    LC111: '4G Router: 4 network ports, dual antenna WiFi',
    T115: '4G portable hotspot: Powered by high-capacity lithium battery, APN can be configured',
    LDW931: '4G USB network card with built-in WiFi',
    GC111: '4G industrial gateway: 4 network ports, dual antenna WiFi, supporting CNC and PLC data acquisition such as Mitsubishi, FANUC and Siemens',
    M55: '5g industrial gateway: 5 gigabit network ports, dual band WiFi, RS232 + RS485, supporting mqtt and secondary development',
    D21: '4G intelligent terminal: Android system, 2.7-inch screen, support hardware encryption, 65W fast charging, 8000mah polymer battery',
    Front_desk_switchboard: 'Reception:',
    Pre_sales_consultation: 'Pre Sales:',
    Contact_customer_service: 'Service:',
    About_rice: 'About us',
    Company_qualification: 'Qualifications',
    Cooperative_partner: 'Partner',
    Industrial_gateway: 'Industrial',
    Wechat_public_platform: 'Platform',
    Electronic_instruction_manual: 'Manual',
    Human_customer_service: 'Service',
    Rice: '©2021 Shenzhen MifiData Technology Co., Ltd',
    Yue_Hao: 'Yue ICP Bei 18130408-1',
    Rhinoceros_cloud: 'Rhinoceros cloud provides enterprise cloud services',
    shop: 'Shop',
    Recruitment_information: 'Recruit',

    // 公司资质
    Enterprise_qualification: 'Enterprise Qualification',
    certificate_p1: 'Rice Business License',
    certificate_p2: 'Rice Trademark',
    certificate_p3: 'Wantang Trademark',
    certificate_p4: 'Niu Meow Trademark',
    certificate_p5: 'Network Access License',
    certificate_p6: 'Niumiao Logo Trademark',
    certificate_p7: 'Multifunctional Mouse Patent',
    certificate_p8: 'Primus 3C Certificate',
    certificate_p9: 'Electronic Equipment Patent',

    // 合作伙伴
    cooperative_partner: 'Cooperative Partner',
    high_pass_span: 'Qualcomm',
    high_pass_p: 'Qualcomm (Qualcomm) is the worlds leading wireless technology innovator and the driving force for 5g R & D, ' +
        'commercialization and scale. We are committed to inventing breakthrough basic technology. Changed the way the world connects,' +
        'calculates and communicates. Connecting mobile phones to the Internet, Qualcomms invention opened the era of mobile Internet. ' +
        'Today, Qualcomms basic technology enables the entire mobile ecosystem, and its inventions are found in every 3G, 4G and 5g smartphone.' +
        'Qualcomm brings the advantages of mobile technology to new industries such as automobile, Internet of things and computing,' +
        'creating a new world in which people and everything can communicate and interact smoothly.',
    millet_span: 'XiaoMi',
    millet_p: 'Xiaomi Technology Co., Ltd. was established on March 3, 2010 [1]. It is a global mobile Internet enterprise focusing' +
        'on the research and development of intelligent hardware and electronic products [2]. It is also an innovative technology ' +
        'enterprise focusing on the construction of high-end smart phones, Internet TV and smart home ecological chain[ 3] Xiaomi has ' +
        'created a model of developing mobile phone operating system with internet mode and enthusiasts participating in the development ' +
        'and improvement“ "Born for fever" is Xiaomis product concept. "Let everyone enjoy the fun of science and technology" is the ' +
        'vision of Xiaomi company. Xiaomi has applied the Internet development model to develop products, made products with the geek ' +
        'spirit, killed intermediate links with the Internet model, and is committed to making everyone in the world.',
    Baidu_span: 'Baidu',
    Baidu_p: 'Baidu is a leading AI company with a strong Internet foundation. Baidus vision is to become the worlds top high-tech ' +
        'company that understands users best and can help people grow“ The word "Baidu" comes from a word of Xin Qiji, a poet of the ' +
        'Southern Song Dynasty 800 years ago: people find him thousands of Baidu. This sentence describes the poets persistent pursuit ' +
        'of ideal. At the end of 1999, Robin Li, who was in the US Silicon Valley, saw the great potential of Chinas Internet and ' +
        'Chinese search engine services. He took the dream of technology changing the world, and he resolutely resigned from Silicon ' +
        'Valleys high paying job and brought the patent technology of search engine to the Baidu Inc in January 1, 2000. Baidu has tens ' +
        'of thousands of R & D engineers, which is a top technical team in China and even the world.',
    Solid_height_span: 'Gugao',
    Solid_height_p: 'Founded in 1999, Gu hi tech is the first high-tech enterprise with independent intellectual property rights in ' +
        'China and the Asia Pacific region focusing on the research and development of motion control and its automation core technology. ' +
        'It is one of the important leading enterprises in the field of intelligent instruments and equipment at home and abroad.The founder' +
        'of Gugao is an internationally renowned expert and scholar in the field of automation and microelectronics, with many years of R & D' +
        'and management experience in world-class scientific research institutions such as the University of California, MIT and Bell Labs. ' +
        'Solid high technology brings together a large number of applications in motion control A scientific and technological elite with unique' +
        'achievements in automation, mechatronics and other fields, is committed to the R & D and application of motion control technology, ' +
        'image and visual sensing technology, mechanical optimization design technology, servo drive technology and related products. The concept' +
        'of solid high technology is:In the field of motion control, we should cultivate first-class motion control technical talents; Provide ' +
        'excellent motion control products and technical services; Help customers in the equipment manufacturing industry become successful enterprises.' +
        'Under the guidance of the policy of "market-oriented and high and new technology as the foothold",We will continue to adhere to the ' +
        '"people-oriented, seize good opportunities", meet new challenges, provide customers with first-class motion control and its automation ' +
        'products, system integration technology, overall solutions and fast and professional technical services, and help customers improve their ' +
        'core competitiveness and become successful.',
    China_Unicom_span: 'China Unicom',
    China_Unicom_p: 'China United Network Communication Group Co., Ltd. (English Name: China Unicom, hereinafter referred to as "China Unicom" ' +
        'and "Unicom") was merged and formed on January 6, 2009 on the basis of the former China Netcom and the former China Unicom,It has branches' +
        'in 31 provinces (autonomous regions and municipalities directly under the central government) in China and many countries and regions abroad. ' +
        'It is the only telecom operator listed in New York, Hong Kong and Shanghai at the same time. It has been selected as the "worlds top 500 ' +
        'enterprises" for many consecutive years. China Unicom is mainly engaged in GSM WCDMA and fdd-lte mobile network services, fixed ' +
        'communication services, domestic and international communication facility services, satellite international dedicated line services, ' +
        'data communication services, network access services and various telecom value-added services,System integration services related to ' +
        'communication and information services, etc. On January 6, 2009, the former China United Communications Co., Ltd. and the former China ' +
        'Network Communications Group Corporation were reorganized and merged, and the new company was renamed China United Network Communications ' +
        'Group Co., Ltd. In order to distinguish it from China Unicom before the merger, the industry often calls it "new Unicom".',
    China_Telecom_span: 'China Telecom',
    China_Telecom_p: 'China Telecom Group Co., Ltd., hereinafter referred to as "China Telecom" or "China Telecom". Founded on April 27, 1995, ' +
        'China Telecom is a super large state-owned communication enterprise in China and a global partner of the Shanghai World Expo. It has been' +
        ' selected as one of the "worlds top 500 enterprises" for many consecutive years, mainly engaged in comprehensive information services ' +
        'such as fixed telephone, mobile communication, satellite communication, Internet access and application. As of December 2019, the group has' +
        '110 million fixed telephone users, 335 million mobile phone users and 150 million broadband users. The total assets of the group company are' +
        '71.964 billion yuan and the total number of employees is more than 400000. On June 6, 2019, the Ministry of industry and information technology' +
        'officially issued 5g commercial license to China Telecom[ 2] On December 18, 2020, China Telecom and Communication University of China signed a' +
        'strategic cooperation framework agreement in Beijing,Jointly promote the development of 5g smart media application and communication industry. ' +
        'At the same time, the two sides also gave full play to their respective resource advantages and jointly established the "5g intelligent media ' +
        'communication and Industry Research Institute". The strategic cooperation between China Telecom and Communication University of China is an ' +
        'important measure to practically promote national strategies such as new infrastructure, digital China and "media integration". China Telecoms ' +
        'Haobai holding company signed a business cooperation agreement with Communication University of China to promote the implementation of specific ' +
        'cooperation projects.',

    // CPE-LC111
    Product_information: 'Product Information',
    lc111_p1: 'Lc111 is a Cat4 grade 4G all Netcom CPE, which can plug in to realize wired and WiFi Internet access; APN is optional, supports mqtt' +
        ' protocol, integrates cloud platform management, traffic speed limit, network diagnostic tools (Ping, traceroute) and other functions; ' +
        'Comply with 3GPP release 9, LTE 4G and 3G standards.',
    Parameter_specification: 'Parameter Specification',
    img: 'Img',
    model: 'Model',
    Interface: 'Interface',
    size: 'Size',
    Introduction_features: 'Introduction',
    lc111_Interface_p1: 'Network Port: 1wan + 3lan',
    lc111_Interface_p2: 'WiFi: dual antenna',
    lc111_p_word: 'Modular design, 4G all Netcom, Cat4 level, support APN + VPN access and cloud platform management',
    Detailed_illustration: 'Detailed Illustration',

    // T115
    t115_p1: 'T115 is a Cat4 level portable wireless router, which supports all Netcom; APN is optional, supports mqtt protocol,' +
        'and integrates cloud platform management and traffic speed limit functions; Integrated network diagnostic tools, such as Ping,' +
        'traceroute, etc.',
    t115_Interface_p1: 'WiFi: built in antenna',
    t115_p_word: 'Battery capacity 1800mAh, 4G all Netcom, Cat4 level, support APN + VPN access and cloud platform management',

    // LDW931
    ldw931_p1: 'Ldw931 is a Cat4 USB network card, which supports all Netcom; APN is optional, supports mqtt protocol, and ' +
        'integrates cloud platform management and traffic speed limit functions; Integrated network diagnostic tools, such as Ping, traceroute, etc.',
    ldw931_Interface_p1: 'WiFi: built in antenna',
    ldw931_p_word: 'USB interface, support windows, Linux and Android systems, 4G all Netcom, Cat4 level, support APN + VPN access and cloud platform management',

    // GC111
    gc111_p1: 'Gc111 is a Cat4 industrial gateway of all Netcom, with industrial design and supporting serial port transparent transmission;' +
        'Support mqtt protocol, at instruction and APN + VPN access; It can be widely used in smart factories, unmanned retail, ' +
        'forest fire prevention and other fields; It has rich interfaces and strong software scalability, and supports secondary development and customization.',
    gc111_Interface_p1: 'Network port: 1wan + 3lan',
    gc111_Interface_p2: 'Serial port: RS232 + RS485',
    gc111_Interface_p3: 'WiFi: dual antenna',
    gc111_p_word: 'Industrial grade, 4G all Netcom, Cat4 standard, support APN + VPN access, cloud platform management, and serial port transparent transmission',

    // T300
    t300_p1: 'T300 is a 4G industrial gateway, which adopts modular design and runs openwrt Linux operating system; With multiple hardware protection,' +
        'it can operate stably even in harsh environment; It can be widely used in smart factories, unmanned retail, forest fire prevention ' +
        'and other fields; It has rich interfaces and strong software scalability, and supports secondary development and customization.',
    t300_Interface_p1: 'Network port: 1wan + 4lan',
    t300_Interface_p2: 'Serial port: RS232 + RS485',
    t300_Interface_p3: '8-bit Di, do',
    t300_p_word: 'Cat4 level, all Netcom, industrial design, support serial port transparent transmission, mqtt protocol,' +
        'APN + VPN access, and support cloud platform management',

    // M55
    m55_p1: 'M55 is a 5g industrial gateway, which supports NSA and SA dual-mode and is downward compatible with 4G / 3G ' +
        'network system; With multiple hardware protection, it can operate stably even in harsh environment; 2.4GHz and 5.8GHz dual' +
        'band WiFi can be widely used in the M2M industry of the Internet of things to provide high-speed, low delay and wide coverage' +
        'transmission networks for smart factories, HD live broadcasting, automatic driving, telemedicine and other fields.',
    m55_Interface_p1: 'Network port: 1wan + 4lan, full Gigabit',
    m55_Interface_p2: 'WiFi: dual band, supporting 802.11ac standard',
    m55_Interface_p3: 'Serial port: RS232 + RS485',
    m55_p_word: 'It supports NSA and SA 5g dual-mode, industrial design, serial port transparent transmission, mqtt protocol, APN + VPN access, and cloud platform management',

    // LM321
    lm321_p1: 'Lm321 is a 4G module encapsulated by LGA, Cat4 standard, supporting all Netcom and rich interfaces;APN is configurable, ' +
        'supports mqtt protocol, and integrates cloud platform management and traffic speed limit functions; Integrated network diagnostic tools, ' +
        'such as Ping, traceroute, etc.',
    lm321_Interface_p1: 'Dual serial port, I2C, SPI',
    lm321_Interface_p2: 'Dual ADC, 20 bit di',
    lm321_Interface_p3: 'DO USB2.0.RMII',
    lm321_p_word: 'Cat4 level, all Netcom, industrial design, support serial port transparent transmission, mqtt protocol, APN + VPN access, and support cloud platform management',

    // D21
    d21_p1: 'D21 is a customized portable terminal, CAT6 standard all Netcom, 8-core 1.8GHz dominant frequency, running Android ' +
        'operating system; Built in encryption chip and algorithm for voice and data secret transmission, support Bluetooth to answer and make calls',
    d21_Interface_p1: 'WiFi: built in antenna',
    d21_Interface_p2: 'Bluetooth 5.1',
    d21_p_word: 'Battery capacity 8000mah, encrypted communication, CAT6 standard',

    // 招聘信息
    Linux_Software_Engineer: 'Linux Software Engineer',
    Job_requirements: 'Job Requirements:',
    Linux_p1: 'Bachelor degree or above in computer science and technology, automation, electronic information engineering and other related majors;',
    Linux_p2: 'Familiar with arm / MIPS architecture, application development on Linux system, serial port, socket, video and audio development experience is preferred;',
    Linux_p3: 'Engineers with 4G and 5g development experience in Qualcomm, MTK and zhanrui platforms are preferred; Engineers with experience in tablet development of rockchip platform are preferred;',
    Linux_p4: 'Have strong teamwork skills, communication skills, sense of responsibility and self-motivated; Have relatively open thinking, good learning and pressure bearing ability;',
    Linux_p5: 'Fresh graduates and interns are welcome.',

    Android_Developer: 'Android Developer',
    Android_p1: 'Computer related major, bachelor degree or above, two years or above Android R & D experience;',
    Android_p2: 'Familiar with android app development: camera, Bluetooth, serial port, JNI, etc;',
    Android_p3: 'Familiar with HTTP, telnet and other communication protocols and principles, and can skillfully develop socket applications;',
    Android_p4: 'Experience in embedded product application and UI development is preferred;',
    Android_p5: 'Strong language expression, communication and organization skills, good team spirit and independent problem-solving ability.',

    Machine_test_engineer: 'Machine Test Engineer',
    Test_p1: 'Participate in product function testing and analysis, find problems in testing and analysis, evaluate project risks, and cooperate with colleagues to ensure that products are switched to production on time;',
    Test_p2: 'Participate in the design, tackling and implementation of test technical scheme, including but not limited to automation test, continuous integration, performance test and other fields;',
    Test_p3: 'During the test process, actively summarize, timely feed back the problems exposed in the process, and try to improve the test method and optimize the process;',
    Test_p4: 'Participate in technical sharing of test team;',

    Resume_delivery: 'Resume delivery email address:',

    // LC800
    Lc800_p1: 'Lc-800 PDA is a handheld maintenance terminal, which integrates industrial computer, optical power, 3000 megabytes (5g, LAN, wifi-6) and Red light source,'+ 
    'HDMI TV simulation and other intelligent comprehensive test products with many functions.',
    Lc800_Interface_p1: 'Dual Gigabit, HDMI input, type-C USB, xgpon laser',
    Lc800_Interface_p2: 'Red light source, NFC, camera',
    Lc800_p_word: '5.5-inch, 1080p resolution, 8000mah battery capacity, 5g and wifi-6 support, 3000m speed measurement',

    Product_performance: 'Product Details',
    Serial_number: 'Serial Number',
    project: 'Project',
    describe: 'Describe',
    td2_1: 'Three Gigabit Network',
    td2_2: 'Operating System',
    td2_3: 'Storage',
    td2_4: 'Screen',
    td2_5: 'Camera',
    td2_6: 'NFC ID card reading',
    td2_7: 'Laser line measurement',
    td2_8: 'GPS, Bluetooth',
    td2_9: 'HDMI TV simulation',
    td2_10: 'IPTV / Ott measurement',
    td2_11: 'Battery capacity',
    td2_12: 'Interface',
    td2_13: 'Size',

    td3_1: 'Cellular Gigabit: 5g, supporting NSA / SA',
    td3_2: 'Wired Gigabit: 2-way, support port mirroring',
    td3_3: 'Wireless Gigabit: wifi-6, supporting MU-MIMO',
    td3_4: 'Android',
    td3_5: 'Standard configuration: 3 + 32GB',
    td3_6: 'Optional: 4 + 64GB and higher',
    td3_7: '5.5-inch, full HD, touch',
    td3_8: 'support',
    td3_10: '1g, 10g power measurement, VFL measurement, ONU opening, PPPoE, etc',
    td3_12: 'It supports 4K input and h.265 code stream recording',
    td3_14: 'Polymer lithium battery, 8000mAh',
    td3_15: 'RJ45 x2',
    td3_16: 'Optical port: FC / SC x2',
    td3_17: 'SIM card: x1',
    td3_18: 'TF Card: x1',
    td3_19: 'HDMI：X1',
    td3_20: 'Type-C USB：x1',
    td3_21: '160*80*25mm',
    
}

